function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, JSON, Object, canManageClassifiedData) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['insights-link'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("a", {
          "attrs": __vjadeStringifyAttrsIfObj({
            href: insightsUrl,
          }),
          "class": {
            'btn-link': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Go to Insights");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const insightsUrl = $attr(`workspace-id`) ? `\/report\/${$attr(`project-id`)}\/view\/${$attr(`workspace-id`)}\/insights` : `\/report\/${$attr(`project-id`)}\/insights`;;
    return {
      value: (h("div", {
        "class": {
          'classification-access-only-banner': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-warning-hero", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'theme': 'default',
            'header-text': `${$attr(`app-name`)} Only Available to Users with Classified Data Access`,
            'body-text': canManageClassifiedData ? `You may want to give yourself and others classified access` : `Contact your admin to request access`
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((canManageClassifiedData) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cta-links': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['insights-link'].call(this));
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: `\/settings\/project/${$attr(`project-id`)}#users`,
                }),
                "class": {
                  'btn-link': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Manage Classified Data Permissions");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cta-links': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['insights-link'].call(this));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "canManageClassifiedData" in locals ? locals.canManageClassifiedData : typeof canManageClassifiedData !== "undefined" ? canManageClassifiedData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;